export default __webpack_public_path__ + "static/media/pexels-christina-morillo-1181396.f18d3b49.jpg";